// extracted by mini-css-extract-plugin
export default {"scroll-loader":"style_scroll-loader__Rcuti__oBlIk","is-popup":"style_is-popup__pCRv2__oBlIk"};